import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const InlineCode = makeShortcode("InlineCode");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Examples`}</h2>
    <h3>{`File tree navigation without directory links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="File navigation">
    <TreeView aria-label="File navigation">
      <TreeView.Item>
        <TreeView.LeadingVisual>
          <TreeView.DirectoryIcon />
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.LinkItem href="#">
            <TreeView.LeadingVisual>
              <FileIcon />
            </TreeView.LeadingVisual>
            Avatar.tsx
            <TreeView.TrailingVisual>
              <StyledOcticon icon={DiffAddedIcon} color="success.fg" aria-label="added" />
            </TreeView.TrailingVisual>
          </TreeView.LinkItem>
          <TreeView.LinkItem href="#" current>
            <TreeView.LeadingVisual>
              <FileIcon />
            </TreeView.LeadingVisual>
            Button.tsx
            <TreeView.TrailingVisual>
              <StyledOcticon icon={DiffModifiedIcon} color="attention.fg" aria-label="modified" />
            </TreeView.TrailingVisual>
          </TreeView.LinkItem>
        </TreeView.SubTree>
      </TreeView.Item>
      <TreeView.LinkItem href="#">
        <TreeView.LeadingVisual>
          <FileIcon />
        </TreeView.LeadingVisual>
        package.json
        <TreeView.TrailingVisual>
          <StyledOcticon icon={DiffModifiedIcon} color="attention.fg" aria-label="modified" />
        </TreeView.TrailingVisual>
      </TreeView.LinkItem>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <h3>{`File tree navigation with directory links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="File navigation">
    <TreeView aria-label="File navigation">
      <TreeView.LinkItem href="#">
        <TreeView.LeadingVisual>
          <TreeView.DirectoryIcon />
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.LinkItem href="#">
            <TreeView.LeadingVisual>
              <FileIcon />
            </TreeView.LeadingVisual>
            Avatar.tsx
          </TreeView.LinkItem>
          <TreeView.LinkItem href="#" current>
            <TreeView.LeadingVisual>
              <TreeView.DirectoryIcon />
            </TreeView.LeadingVisual>
            Button
            <TreeView.SubTree>
              <TreeView.LinkItem href="#">
                <TreeView.LeadingVisual>
                  <FileIcon />
                </TreeView.LeadingVisual>
                Button.tsx
              </TreeView.LinkItem>
              <TreeView.LinkItem href="#">
                <TreeView.LeadingVisual>
                  <FileIcon />
                </TreeView.LeadingVisual>
                Button.test.tsx
              </TreeView.LinkItem>
            </TreeView.SubTree>
          </TreeView.LinkItem>
        </TreeView.SubTree>
      </TreeView.LinkItem>
      <TreeView.LinkItem href="#">
        <TreeView.LeadingVisual>
          <FileIcon />
        </TreeView.LeadingVisual>
        package.json
      </TreeView.LinkItem>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <h3>{`With controlled expanded state`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`function ControlledTreeView() {
  const [expanded, setExpanded] = React.useState(false)

  return (
    <Box sx={{display: 'grid', gap: 2, maxWidth: 400}}>
      <Button onClick={() => setExpanded(!expanded)}>{expanded ? 'Collapse' : 'Expand'}</Button>
      <nav aria-label="File navigation">
        <TreeView aria-label="File navigation">
          <TreeView.Item expanded={expanded} onExpandedChange={setExpanded}>
            src
            <TreeView.SubTree>
              <TreeView.LinkItem href="#">Avatar.tsx</TreeView.LinkItem>
              <TreeView.LinkItem href="#" current>
                Button.tsx
              </TreeView.LinkItem>
            </TreeView.SubTree>
          </TreeView.Item>
        </TreeView>
      </nav>
    </Box>
  )
}

render(<ControlledTreeView />)
`}</code></pre>
    <h3>{`With stateful visuals`}</h3>
    <p>{`To render stateful visuals, pass a render function to `}<inlineCode parentName="p">{`TreeView.LeadingVisual`}</inlineCode>{` or `}<inlineCode parentName="p">{`TreeView.TrailingVisual`}</inlineCode>{`. The function will be called with the `}<inlineCode parentName="p">{`expanded`}</inlineCode>{` state of the item.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="File navigation">
    <TreeView aria-label="File navigation">
      <TreeView.Item>
        <TreeView.LeadingVisual>
          {({isExpanded}) => (isExpanded ? <FileDirectoryOpenFillIcon /> : <FileDirectoryFillIcon />)}
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.LinkItem href="#">Avatar.tsx</TreeView.LinkItem>
          <TreeView.LinkItem href="#" current>
            Button.tsx
          </TreeView.LinkItem>
        </TreeView.SubTree>
      </TreeView.Item>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <p>{`Since stateful directory icons are a common use case for TreeView, we provide a `}<inlineCode parentName="p">{`TreeView.DirectoryIcon`}</inlineCode>{` component for convenience. The previous example can be rewritten as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{maxWidth: 400}}>
  <nav aria-label="File navigation">
    <TreeView aria-label="File navigation">
      <TreeView.Item>
        <TreeView.LeadingVisual>
          <TreeView.DirectoryIcon />
        </TreeView.LeadingVisual>
        src
        <TreeView.SubTree>
          <TreeView.LinkItem href="#">Avatar.tsx</TreeView.LinkItem>
          <TreeView.LinkItem href="#" current>
            Button.tsx
          </TreeView.LinkItem>
        </TreeView.SubTree>
      </TreeView.Item>
    </TreeView>
  </nav>
</Box>
`}</code></pre>
    <h3>{`With asynchronously loaded items`}</h3>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://primer.style/react/storybook?path=/story/components-treeview--async-success"
      }}>{`Storybook`}</a>{` for examples with asynchronously loaded items.`}</p>
    <h2>{`Props`}</h2>
    <h3>{`TreeView`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" required mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.Item`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" required mdxType="PropsTableRow" />
  <PropsTableRow name="current" type="boolean" defaultValue="false" description="Whether the item is the current item. No more than one item should be current at once. The path to the current item will be expanded by default." mdxType="PropsTableRow" />
  <PropsTableRow name="defaultExpanded" type="boolean" description="The expanded state of the item when it is initially rendered. Use when you do not need to control the state." mdxType="PropsTableRow" />
  <PropsTableRow name="expanded" type="boolean" description="The controlled expanded state of item. Must be used in conjunction with onExpandedChange." mdxType="PropsTableRow" />
  <PropsTableRow name="onExpandedChange" type="(expanded: boolean) => void" description="Event handler called when the expanded state of the item changes." mdxType="PropsTableRow" />
  <PropsTableRow name="onSelect" type="(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void" mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.LinkItem`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" required mdxType="PropsTableRow" />
  <PropsTableRow name="href" type="string" description={<>
        The URL that the item navigates to. <InlineCode mdxType="InlineCode">href</InlineCode> is passed to the underlying{' '}
        <InlineCode mdxType="InlineCode">&lt;a&gt;</InlineCode> element. If <InlineCode mdxType="InlineCode">as</InlineCode> is specified, the component may need
        different props. If the item contains a sub-nav, the item is rendered as a{' '}
        <InlineCode mdxType="InlineCode">&lt;button&gt;</InlineCode> and <InlineCode mdxType="InlineCode">href</InlineCode> is ignored.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="current" type="boolean" defaultValue="false" description="Whether the item is the current item. No more than one item should be current at once. The path to the current item will be expanded by default." mdxType="PropsTableRow" />
  <PropsTableRow name="defaultExpanded" type="boolean" description="The expanded state of the item when it is initially rendered. Use when you do not need to control its state." mdxType="PropsTableRow" />
  <PropsTableRow name="expanded" type="boolean" description="The controlled expanded state of item. Must be used in conjunction with onExpandedChange." mdxType="PropsTableRow" />
  <PropsTableRow name="onExpandedChange" type="(expanded: boolean) => void" description="Event handler called when the expanded state of the item changes." mdxType="PropsTableRow" />
  <PropsTableRow name="onSelect" type="(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void" mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.LoadingItem`}</h3>
    <PropsTable mdxType="PropsTable">{
        /* <PropsTableSxRow /> */
      }</PropsTable>
    <h3>{`TreeView.SubTree`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.LeadingVisual`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type={`| React.ReactNode
| (props: {isExpanded: boolean}) => React.ReactNode`} mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.TrailingVisual`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type={`| React.ReactNode
| (props: {isExpanded: boolean}) => React.ReactNode`} mdxType="PropsTableRow" />
  {
        /* <PropsTableSxRow /> */
      }
    </PropsTable>
    <h3>{`TreeView.DirectoryIcon`}</h3>
    <PropsTable mdxType="PropsTable">{
        /* <PropsTableSxRow /> */
      }</PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: false,
      adaptsToThemes: false,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      